import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allClients } from 'app/mocks/data/park/clients'

import { api } from 'app/utils/constants'

import { Service, ServicePayload } from 'app/types/users/service'

export const createService = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.services.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = ServicePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Service>(
            {
                id: 999,
                ...payloadParsed.data,
                client: allClients.find(
                    (client) => client.id === payloadParsed.data.client,
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
